let moment = require('moment');

const validate = values => {
    const errors = {}
    if (!values.renaper_document_number) {
		errors.renaper_document_number = 'Este Campo es Obligatorio'
	}
	if ( !/(\d{7}|\d{8})$/.test(values.renaper_document_number)) {
		errors.renaper_document_number = 'El documento no es válido'
	}
	if (!values.renaper_name) {
		errors.renaper_name = 'Este Campo es Obligatorio'
	}
    if (!values.renaper_lastname) {
		errors.renaper_lastname = 'Este Campo es Obligatorio'
	}

    if (!/(\d{11})$/.test(values.renaper_process_number)) {
		errors.renaper_process_number = 'Formato inválido'
    }

	if (!values.renaper_birth_date) {
		errors.renaper_birth_date = 'Este Campo es Obligatorio'
	}

    if (values.renaper_birth_date) {
		if(/^[0-3][0-9]\/[0-1][0-9]\/[1-2][0-9][0-9][0-9]$/.test(values.renaper_birth_date)){
			const dateDigits = values.renaper_birth_date.split('/').join('');
			const formatedBornDate = dateDigits.replace(/(\d{2})(\d{2})(\d{4})/, '$3-$2-$1');
			if (!Date.parse(formatedBornDate)){
				errors.renaper_birth_date = 'Formato inválido'
			}
		} else{
			errors.renaper_birth_date = 'Formato inválido'
		}
    }

	return errors
}

export default validate


/** WEBPACK FOOTER **
 ** ./src/components/Validations/submitValidationRenaperDocumentInformation.js
 **/